export const PROVIDERS = {
  google: {
    name: 'Google Ads',
    icon: 'i-logos-google-ads',
    color: 'blue',
  },
  meta: {
    name: 'Meta Ads',
    icon: 'i-logos-meta-icon',
    color: 'iris',
  },
};

export const formatCurrency = (minorValue, currency = 'BRL') =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format(Number(minorValue || 0) / 100);

export const formatNumber = value =>
  new Intl.NumberFormat(undefined).format(Number(value || 0));

export const displayGoalName = name =>
  name?.replace(/^\[Exemplo\]\s*/, '') || '';

export const formatDate = value => {
  if (!value) return '—';
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
};

export const statusColor = status => {
  if (
    [
      'active',
      'ready',
      'connected',
      'enabled',
      'succeeded',
      'accepted',
      'attributed',
    ].includes(status)
  )
    return 'teal';
  if (
    [
      'pending',
      'queued',
      'running',
      'processing',
      'retry_scheduled',
      'not_configured',
      'needs_adjustment',
    ].includes(status)
  )
    return 'amber';
  if (['action_required', 'failed', 'rejected', 'error'].includes(status))
    return 'ruby';
  return 'slate';
};

export const localizedStatus = (t, status) =>
  t(`ads.statuses.${status || 'pending'}`);

export const localizedSource = (t, source) =>
  t(`ads.sources.${source || 'unknown'}`);

export const localizedCampaignLevel = (t, level) =>
  t(`ads.campaignLevels.${level || 'campaign'}`);

export const providerMessage = (t, provider, key) =>
  t(`ads.providers.${provider}.${key}`);
